import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Label } from '../components/ui/Label';
import { Button } from '../components/ui/Button';
import { MapPin, Phone, Mail, Send, Download } from 'lucide-react';
import { CFA_INFO } from '../data/constants';
import { toast } from 'sonner';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      toast.success('Votre message a bien été envoyé. Nous vous répondrons dans les plus brefs délais.');
    }, 1000);
  };
  const handleDownloadClick = (e: React.MouseEvent) => {
    e.preventDefault();
    toast.info('Le catalogue sera bientôt disponible au téléchargement.');
  };
  return <div className="flex flex-col w-full" data-id="element-1023" data-mp="19exmklqwa86b">
      <PageHeader title="Contactez-nous" subtitle="Une question sur nos formations, l'alternance ou notre CFA ? Notre équipe est à votre disposition." data-id="element-1024" data-mp="1e78r61wkyi57" />
      <div className="py-16 md:py-24 bg-muted relative overflow-hidden" data-id="element-1025" data-mp="mgkq0puwpcrj">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-1026" data-mp="mino7x67qc7c" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-1027" data-mp="vhixji4k02ev">
          <div className="grid lg:grid-cols-3 gap-16" data-id="element-1028" data-mp="vjbzwl84w0h2">
            {/* Contact Info */}
            <div className="lg:col-span-1 space-y-10" data-id="element-1029" data-mp="10hn9qvyfiaza">
              <div data-id="element-1030" data-mp="26x7ftw6v4d9c">
                <h2 className="text-3xl font-extrabold font-heading text-primary-dark mb-8" data-id="element-1031" data-mp="26vmn8c43z4e4">
                  Nos coordonnées
                </h2>
                <div className="space-y-8" data-id="element-1032" data-mp="1m7dbbcqr9dfd">
                  <div className="flex items-start gap-5 group" data-id="element-1033" data-mp="1m627xe1827os">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1034" data-mp="1h8is49ovlmuq">
                      <MapPin className="w-6 h-6 text-brand-orange animate-soft-bounce" data-id="element-1035" data-mp="1w3gn7abesqfi" />
                    </div>
                    <div data-id="element-1036" data-mp="13gvlph17yxy8">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1037" data-mp="13gcbynlq3fva">
                        Adresse
                      </h3>
                      <p className="text-muted-foreground leading-relaxed" data-id="element-1038" data-mp="yjc6adsscf4p">
                        {CFA_INFO.address}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-5 group" data-id="element-1039" data-mp="18edyxjm9rzc1">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1040" data-mp="kpkxx8qsj1ak">
                      <Phone className="w-6 h-6 text-brand-orange animate-soft-bounce" style={{
                      animationDelay: '0.2s'
                    }} data-id="element-1041" data-mp="fpgpm601dcvf" />
                    </div>
                    <div data-id="element-1042" data-mp="2hi1tnhljmron">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1043" data-mp="2hemc884ed6k2">
                        Téléphone
                      </h3>
                      <p className="text-muted-foreground leading-relaxed" data-id="element-1044" data-mp="3a4ux47qbi52c">
                        {CFA_INFO.phone}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-5 group" data-id="element-1045" data-mp="314zjlw9ahxz5">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1046" data-mp="316smd0gs7y1v">
                      <Mail className="w-6 h-6 text-brand-orange animate-soft-bounce" style={{
                      animationDelay: '0.4s'
                    }} data-id="element-1047" data-mp="1pnpyl5aiixvq" />
                    </div>
                    <div data-id="element-1048" data-mp="2570yp05gctmn">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1049" data-mp="255pw33nqtrx4">
                        Email
                      </h3>
                      <a href={`mailto:${CFA_INFO.email}`} className="text-primary font-medium hover:text-brand-orange transition-colors underline underline-offset-4" data-id="element-1050" data-mp="205v8b8z9liga">
                        {CFA_INFO.email}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-10 border-t border-slate-200" data-id="element-1051" data-mp="2j0jygpicxobe">
                <h2 className="text-2xl font-extrabold font-heading text-primary-dark mb-6" data-id="element-1052" data-mp="2ewkj4a8tcvjm">
                  Accès rapides
                </h2>
                <div className="flex flex-col gap-4" data-id="element-1053" data-mp="13hymnpoyzwy7">
                  <Button className="w-full justify-start py-6 text-base bg-primary hover:bg-primary-dark text-white shadow-md" asChild data-id="element-1054" data-mp="13gdrpyyqubzt">
                    <Link to="/candidater" data-id="element-1055" data-mp="3j7f8pj8pidjm">Candidater à une formation</Link>
                  </Button>
                  <Button variant="outline" className="w-full justify-start py-6 text-base border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" asChild data-id="element-1056" data-mp="3o4fh40t13sdw">
                    <Link to="/entreprises" data-id="element-1057" data-mp="6p8p6nr0ji9h">Recruter un alternant</Link>
                  </Button>
                  <Button variant="secondary" className="w-full justify-start py-6 text-base bg-lavande text-primary-dark hover:bg-lavande/80 font-semibold" onClick={handleDownloadClick} data-id="element-1058" data-mp="arc27gtbyuwv">
                    <Download className="w-5 h-5 mr-3" data-id="element-1059" data-mp="2ckjrnj2nqswh" />
                    Télécharger le catalogue
                  </Button>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2" data-id="element-1060" data-mp="3ftcq2aslglft">
              <Card className="border-none shadow-2xl bg-white overflow-hidden" data-id="element-1061" data-mp="3fueah5vi2ka7">
                <div className="h-2 w-full bg-gradient-to-r from-primary to-brand-orange" data-id="element-1062" data-mp="3tte12j2kp990" />
                <CardContent className="p-8 md:p-12" data-id="element-1063" data-mp="3otj9seevyhnf">
                  <h2 className="text-3xl font-extrabold font-heading text-primary-dark mb-8" data-id="element-1064" data-mp="3ow5i4g9lp16p">
                    Envoyez-nous un message
                  </h2>

                  {isSuccess ? <div className="bg-green-50 text-green-800 p-6 rounded-lg border border-green-200 text-center" data-id="element-1065" data-mp="2kqfq34c1m1g">
                      <h3 className="text-lg font-bold mb-2" data-id="element-1066" data-mp="gg2ceg21tml0">
                        Message envoyé !
                      </h3>
                      <p data-id="element-1067" data-mp="qbvra638ps5y">
                        Merci de nous avoir contactés. Notre équipe reviendra
                        vers vous très rapidement.
                      </p>
                      <Button variant="outline" className="mt-6" onClick={() => setIsSuccess(false)} data-id="element-1068" data-mp="14zdq4nu4fskg">
                        Envoyer un autre message
                      </Button>
                    </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1069" data-mp="zz83jm2pkw98">
                      <div className="grid sm:grid-cols-2 gap-6" data-id="element-1070" data-mp="m8wddspop7kq">
                        <div className="space-y-2" data-id="element-1071" data-mp="m6jlonu4jiuh">
                          <Label htmlFor="name" data-id="element-1072" data-mp="qzl2j1dw5sgp">Nom complet</Label>
                          <Input id="name" required placeholder="Jean Dupont" data-id="element-1073" data-mp="caglvomqvwap" />
                        </div>
                        <div className="space-y-2" data-id="element-1074" data-mp="h99zdh217nav">
                          <Label htmlFor="email" data-id="element-1075" data-mp="ha1hbp2phmio">Adresse email</Label>
                          <Input id="email" type="email" required placeholder="jean.dupont@email.com" data-id="element-1076" data-mp="39ihh58e9mrl" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-1077" data-mp="irid0y22e6qc">
                        <Label htmlFor="subject" data-id="element-1078" data-mp="ipp7jm36tsjx">Sujet</Label>
                        <Input id="subject" required placeholder="Demande d'information sur le BTS NDRC" data-id="element-1079" data-mp="drdtez5v0vvw" />
                      </div>
                      <div className="space-y-2" data-id="element-1080" data-mp="4u3ff61nqsna">
                        <Label htmlFor="message" data-id="element-1081" data-mp="92qmkgzdxp">Message</Label>
                        <Textarea id="message" required placeholder="Votre message..." className="min-h-[150px]" data-id="element-1082" data-mp="3r7layc3dkh1h" />
                      </div>
                      <Button type="submit" className="w-full sm:w-auto bg-brand-orange hover:bg-[#E67E22] text-white text-lg px-8 py-6 shadow-xl" disabled={isSubmitting} data-id="element-1083" data-mp="3h8m7r91dpdlv">
                        {isSubmitting ? 'Envoi en cours...' : <>
                            <Send className="w-5 h-5 mr-2" data-id="element-1084" data-mp="21on344h4im8q" />
                            Envoyer le message
                          </>}
                      </Button>
                    </form>}
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>;
}